import { render, staticRenderFns } from "./AuthIdentity.vue?vue&type=template&id=16c56aad&"
import script from "./AuthIdentity.vue?vue&type=script&lang=js&"
export * from "./AuthIdentity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports